export const supportedFreeTranslationLanguages = {
  Afrikaans: "af",
  Akan: "ak",
  Albanian: "sq",
  Amharic: "am",
  Arabic: "ar",
  Armenian: "hy",
  Assamese: "as",
  "Azerbaijani (Latin)": "az",
  Aymara: "ay",
  Bangla: "bn",
  Basque: "eu",
  Belarusian: "be",
  Bhojpuri: "bho",
  "Bosnian (Latin)": "bs",
  Bulgarian: "bg",
  Catalan: "ca",
  Cebuano: "ceb",
  Chinese: "zh",
  "Chinese (China)": "zh-CN",
  "Chinese (Hong Kong)": "zh-HK",
  "Chinese (Singapore)": "zh-SG",
  "Chinese (Taiwan)": "zh-TW",
  "Chinese Simplified": "zh-Hans",
  "Chinese Traditional": "zh-Hant",
  Corsican: "co",
  Croatian: "hr",
  Czech: "cs",
  Danish: "da",
  Divehi: "dv",
  Dutch: "nl",
  English: "en",
  "English (United States)": "en-US",
  Esperanto: "eo",
  Estonian: "et",
  Ewe: "ee",
  Filipino: "fil",
  Finnish: "fi",
  French: "fr",
  Galician: "gl",
  Ganda: "lg",
  Georgian: "ka",
  German: "de",
  Greek: "el",
  Guarani: "gn",
  Gujarati: "gu",
  "Haitian Creole": "ht",
  "Hakka Chinese (Taiwan)": "hak-TW",
  Hausa: "ha",
  Hawaiian: "haw",
  Hebrew: "iw",
  Hindi: "hi",
  Hungarian: "hu",
  Hmong: "hmn",
  Icelandic: "is",
  Igbo: "ig",
  Indonesian: "id",
  Irish: "ga",
  Italian: "it",
  Japanese: "ja",
  Javanese: "jv",
  Kannada: "kn",
  Kazakh: "kk",
  Khmer: "km",
  Kinyarwanda: "rw",
  Korean: "ko",
  Krio: "kri",
  "Kurdish (Central)": "ku",
  "Kyrgyz (Cyrillic)": "ky",
  Lao: "lo",
  Latin: "la",
  Latvian: "lv",
  Lithuanian: "lt",
  Lingala: "ln",
  Luxembourgish: "lb",
  Macedonian: "mk",
  Malagasy: "mg",
  "Malay (Latin)": "ms",
  Malayalam: "ml",
  Maltese: "mt",
  Maori: "mi",
  Marathi: "mr",
  "Min Nan Chinese (Taiwan)": "nan-TW",
  Mongolian: "mn",
  Myanmar: "my",
  Nepali: "ne",
  Norwegian: "no",
  Nyanja: "ny",
  Odia: "or",
  Oromo: "om",
  Pashto: "ps",
  Persian: "fa",
  Polish: "pl",
  "Portuguese (Brazil)": "pt",
  Punjabi: "pa",
  Quechua: "qu",
  Romanian: "ro",
  Russian: "ru",
  "Samoan (Latin)": "sm",
  Sanskrit: "sa",
  "Scottish Gaelic": "gd",
  Serbian: "sr",
  Sesotho: "st",
  "Sesotho sa Leboa": "nso",
  Shona: "sn",
  Sindhi: "sd",
  Sinhala: "si",
  Slovak: "sk",
  Slovenian: "sl",
  "Somali (Arabic)": "so",
  Sundanese: "su",
  Spanish: "es",
  "Swahili (Latin)": "sw",
  Swedish: "sv",
  Tamil: "ta",
  Tajik: "tg",
  "Tatar (Latin)": "tt",
  Telugu: "te",
  Thai: "th",
  Tigrinya: "ti",
  Turkish: "tr",
  "Turkmen (Latin)": "tk",
  Tsonga: "ts",
  Ukrainian: "uk",
  Urdu: "ur",
  "Uyghur (Arabic)": "ug",
  "Uzbek (Latin)": "uz",
  Vietnamese: "vi",
  Welsh: "cy",
  "Western Frisian": "fy",
  Xhosa: "xh",
  Yiddish: "yi",
  Yoruba: "yo",
  Zulu: "zu",
} as const;

export const supportedTranslationLanguages = {
  Afrikaans: "af",
  Albanian: "sq",
  Amharic: "am",
  Arabic: "ar",
  Armenian: "hy",
  Assamese: "as",
  "Azerbaijani (Latin)": "az",
  Bangla: "bn",
  Bashkir: "ba",
  Basque: "eu",
  Bhojpuri: "bho",
  Bodo: "brx",
  "Bosnian (Latin)": "bs",
  Bulgarian: "bg",
  "Cantonese (Traditional)": "yue",
  Catalan: "ca",
  "Chinese (Literary)": "lzh",
  "Chinese Simplified": "zh-Hans",
  "Chinese Traditional": "zh-Hant",
  chiShona: "sn",
  Croatian: "hr",
  Czech: "cs",
  Danish: "da",
  Dari: "prs",
  Divehi: "dv",
  Dogri: "doi",
  Dutch: "nl",
  English: "en",
  Estonian: "et",
  Faroese: "fo",
  Fijian: "fj",
  Filipino: "fil",
  Finnish: "fi",
  French: "fr",
  "French (Canada)": "fr-ca",
  Galician: "gl",
  Georgian: "ka",
  German: "de",
  Greek: "el",
  Gujarati: "gu",
  "Haitian Creole": "ht",
  Hausa: "ha",
  Hebrew: "he",
  Hindi: "hi",
  "HmongDaw (Latin)": "mww",
  Hungarian: "hu",
  Icelandic: "is",
  Igbo: "ig",
  Indonesian: "id",
  Inuinnaqtun: "ikt",
  Inuktitut: "iu",
  "Inuktitut (Latin)": "iu-Latn",
  Irish: "ga",
  Italian: "it",
  Japanese: "ja",
  Kannada: "kn",
  Kashmiri: "ks",
  Kazakh: "kk",
  Khmer: "km",
  Kinyarwanda: "rw",
  Klingon: "tlh-Latn",
  "Klingon (plqaD)": "tlh-Piqd",
  Konkani: "gom",
  Korean: "ko",
  "Kurdish (Central)": "ku",
  "Kurdish (Northern)": "kmr",
  "Kyrgyz (Cyrillic)": "ky",
  Lao: "lo",
  Latvian: "lv",
  Lithuanian: "lt",
  Lingala: "ln",
  "Lower Sorbian": "dsb",
  Luganda: "lug",
  Macedonian: "mk",
  Maithili: "mai",
  Malagasy: "mg",
  "Malay (Latin)": "ms",
  Malayalam: "ml",
  Maltese: "mt",
  Maori: "mi",
  Marathi: "mr",
  "Mongolian (Cyrillic)": "mn-Cyrl",
  "Mongolian (Traditional)": "mn-Mong",
  Myanmar: "my",
  Nepali: "ne",
  Norwegian: "nb",
  Nyanja: "nya",
  Odia: "or",
  Pashto: "ps",
  Persian: "fa",
  Polish: "pl",
  "Portuguese (Brazil)": "pt",
  "Portuguese (Portugal)": "pt-pt",
  Punjabi: "pa",
  "Queretaro Otomi": "otq",
  Romanian: "ro",
  Rundi: "run",
  Russian: "ru",
  "Samoan (Latin)": "sm",
  "Serbian (Cyrillic)": "sr-Cyrl",
  "Serbian (Latin)": "sr-Latn",
  Sesotho: "st",
  "Sesotho sa Leboa": "nso",
  Setswana: "tn",
  Sindhi: "sd",
  Sinhala: "si",
  Slovak: "sk",
  Slovenian: "sl",
  "Somali (Arabic)": "so",
  Spanish: "es",
  "Swahili (Latin)": "sw",
  Swedish: "sv",
  Tahitian: "ty",
  Tamil: "ta",
  "Tatar (Latin)": "tt",
  Telugu: "te",
  Thai: "th",
  Tibetan: "bo",
  Tigrinya: "ti",
  Tongan: "to",
  Turkish: "tr",
  "Turkmen (Latin)": "tk",
  Ukrainian: "uk",
  "Upper Sorbian": "hsb",
  Urdu: "ur",
  "Uyghur (Arabic)": "ug",
  "Uzbek (Latin)": "uz",
  Vietnamese: "vi",
  Welsh: "cy",
  Xhosa: "xh",
  Yoruba: "yo",
  "Yucatec Maya": "yua",
  Zulu: "zu",
} as const;

export const supportedLanguages = {
  Afrikaans: "af",
  Arabic: "ar",
  Armenian: "hy",
  Azerbaijani: "az",
  Belarusian: "be",
  Bosnian: "bs",
  Bulgarian: "bg",
  Catalan: "ca",
  Chinese: "zh",
  Croatian: "hr",
  Czech: "cs",
  Danish: "da",
  Dutch: "nl",
  English: "en",
  Estonian: "et",
  Finnish: "fi",
  French: "fr",
  Galician: "gl",
  German: "de",
  Greek: "el",
  Hebrew: "he",
  Hindi: "hi",
  Hungarian: "hu",
  Icelandic: "is",
  Indonesian: "id",
  Italian: "it",
  Japanese: "ja",
  Kannada: "kn",
  Kazakh: "kk",
  Korean: "ko",
  Latvian: "lv",
  Lithuanian: "lt",
  Macedonian: "mk",
  Malay: "ms",
  Marathi: "mr",
  Maori: "mi",
  Nepali: "ne",
  Norwegian: "no",
  Persian: "fa",
  Polish: "pl",
  Portuguese: "pt",
  Romanian: "ro",
  Russian: "ru",
  Serbian: "sr",
  Slovak: "sk",
  Slovenian: "sl",
  Spanish: "es",
  Swahili: "sw",
  Swedish: "sv",
  Tagalog: "tl",
  Tamil: "ta",
  Thai: "th",
  Turkish: "tr",
  Ukrainian: "uk",
  Urdu: "ur",
  Vietnamese: "vi",
  Welsh: "cy",
} as const;

export const mergedLanguages = {
  ...supportedLanguages,
  ...supportedTranslationLanguages,
} as const;

export type TranslationLanguageValue = (typeof supportedTranslationLanguages)[keyof typeof supportedTranslationLanguages];

export type MergedLanguageKey = Lowercase<keyof typeof mergedLanguages>;
export type MergedLanguageValue = (typeof mergedLanguages)[keyof typeof mergedLanguages];
export type MergedLanguageType = MergedLanguageKey | MergedLanguageValue;

export function getTranslationCode(language: keyof typeof supportedTranslationLanguages) {
  return supportedTranslationLanguages[language];
}

export function getLanguageEntry(lang: MergedLanguageType) {
  const entry = Object.entries(mergedLanguages).find(([key, value]) => {
    if (lang === value) return true;
    if (lang === key.toLowerCase()) return true;
    return false;
  });

  return entry ?? ["English", "en"];
}

export function getLanguageCode(lang: MergedLanguageType): MergedLanguageValue {
  const code = Object.entries(mergedLanguages).find(([key, value]) => {
    if (lang === value) return true;
    if (lang === key.toLowerCase()) return true;
    return false;
  })?.[1];

  return code ?? "en";
}
